import upperFirst from 'lodash/fp/upperFirst';
import styles from './Margin.module.scss';
import { SupportedSize } from './Element';

export type MarginProps = {
  size?: SupportedSize;
  vertical?: SupportedSize;
  horizontal?: SupportedSize;
  left?: SupportedSize;
  right?: SupportedSize;
  top?: SupportedSize;
  bottom?: SupportedSize;
  lastChild?: {
    bottom?: boolean;
  };
};

// Alias for backwards compatibility
export type MarginShape = MarginProps;

export default ({
  size,
  vertical = size,
  horizontal = size,
  left = horizontal,
  right = horizontal,
  top = vertical,
  bottom = vertical,
  lastChild,
}: MarginProps) => {
  const classes: string[] = [];

  if (left) classes.push(styles[`margin__size${upperFirst(left)}Left`]);
  if (right) classes.push(styles[`margin__size${upperFirst(right)}Right`]);
  if (top) classes.push(styles[`margin__size${upperFirst(top)}Top`]);
  if (bottom) classes.push(styles[`margin__size${upperFirst(bottom)}Bottom`]);
  if (lastChild?.bottom === false)
    classes.push(styles[`margin__lastChildSizeZeroBottom`]);

  return classes;
};
